<template>
<span style="display: none;">
</span>
</template>

<script>
/*

JtQkboSFEPY8BZQQmg42nmjvBnH2:
"WXeS2XO0rRMHUZGIKl4fPXYR4Z93"

WXeS2XO0rRMHUZGIKl4fPXYR4Z93:
"9MUCYwfjYVfdF4sfEGlIt6khceq2"
*/
import * as THREE from 'three'
var raycaster = new THREE.Raycaster()
var mouse = new THREE.Vector2()
/* eslint-disable */
function onMouseMove(event) {
	// calculate mouse position in normalized device coordinates
	// (-1 to +1) for both components
	mouse.x = (event.clientX / window.innerWidth) * 2 - 1
	mouse.y = - (event.clientY / window.innerHeight) * 2 + 1
}
window.addEventListener('mousemove', onMouseMove, false)


function onTouchMove(event) {
	// calculate mouse position in normalized device coordinates
	// (-1 to +1) for both components
	mouse.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1
	mouse.y = - (event.touches[0].clientY / window.innerHeight) * 2 + 1
}
window.addEventListener('touchmove', onTouchMove, false)


function onTouchStart(event) {
	// calculate mouse position in normalized device coordinates
	// (-1 to +1) for both components
	mouse.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1
	mouse.y = - (event.touches[0].clientY / window.innerHeight) * 2 + 1
}
window.addEventListener('touchstart', onTouchStart, false)

let resolution = new THREE.Vector2(window.innerWidth, window.innerHeight)
window.addEventListener('resize', () => {
  resolution.x = window.innerWidth
  resolution.y = window.innerHeight
})

window.addEventListener('orientationchange', () => {
  resolution.x = window.innerWidth
  resolution.y = window.innerHeight
})

const FSCalc = ({ zPos, camera }) => {
  var cameraZ = camera.position.z
  var distance = cameraZ - zPos
  var aspect = window.innerWidth / window.innerHeight
  var vFov = camera.fov * Math.PI / 180
  var planeHeightAtDistance = 2 * Math.tan(vFov / 2) * distance
  var planeWidthAtDistance = planeHeightAtDistance * aspect

  /*
  let dist = camera.position.z - mesh.position.z
  let height = ... // desired height to fit
  camera.fov = 2 * Math.atan(height / (2 * dist)) * (180 / Math.PI)
  camera.updateProjectionMatrix()
  */

  return {
    aspect: planeWidthAtDistance / planeHeightAtDistance,
    vmin: Math.min(planeWidthAtDistance, planeHeightAtDistance),
    vmax: Math.max(planeWidthAtDistance, planeHeightAtDistance),
    width: planeWidthAtDistance,
    height: planeHeightAtDistance
  }
}
window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    var start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        }
      });
    }, 1);
  }

window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  }
/* eslint-enable */

export default {
  props: {
    root: {
      required: true
    },
    myInfo: {
      required: true
    },
    players: {
      required: true
    },
    toucher: {
      required: true
    },
    engine: {
      required: true
    },
    activeTiles: {
      required: true
    },
    highlightTiles: {
      required: true
    },
    deadCells: {
      required: true
    },
    deadAround: {
      required: true
    },
    cleaner: {
      required: true
    }
  },
  data () {
    return {
      hover: false,
      intersects: [],
      hasLeft: false,
      pointcloud: false
    }
  },
  watch: {
    hover () {
      this.$emit('hover', this.hover)
    }
  },
  mounted () {
    var PARTICLE_SIZE = 25.0

    let counter = this.root.xnum * this.root.ynum
    var mood = new Float32Array(counter * 1)

    var positions = new Float32Array(counter * 3)
    var cellColorsArray = new Float32Array(counter * 3)
    var borderColorsArray = new Float32Array(counter * 3)
    var stridesMap = {}
    var color = new THREE.Color()

    let xmax = this.root.xnum
    let ymax = this.root.ynum
    let stride3 = 0
    // let stride2 = 0
    let stride1 = 0
    for (var column = 0; column < ymax; column++) {
      for (var row = 0; row < xmax; row++) {
        let root = this.root
        let sizePlusPad = PARTICLE_SIZE
        let br = root.bricks[stride1]
        let { x, y, z } = {
          x: br.xid * sizePlusPad - (root.xnum) * sizePlusPad * 0.5,
          y: br.yid * sizePlusPad - (root.ynum) * sizePlusPad * 0.5,
          z: 0
        }

        stridesMap[br.numID] = stride1

        mood[stride1 + 0.0] = 0

        positions[stride3 + 0.0] = x * 1.05
        positions[stride3 + 1.0] = y * -1.05
        positions[stride3 + 2.0] = z

        // color.setHSL((stride1 / counter), 1.0, 0.7)
        // color.setHSL(0.5, 0.5, 0.7)
        color.setHex(0x100B36)

        cellColorsArray[stride3 + 0.0] = color.r
        cellColorsArray[stride3 + 1.0] = color.g
        cellColorsArray[stride3 + 2.0] = color.b

        // color.setHSL(((counter - stride1) / counter), 1.0, 0.5)

        color.setHex(0x0A0721)

        borderColorsArray[stride3 + 0.0] = color.r
        borderColorsArray[stride3 + 1.0] = color.g
        borderColorsArray[stride3 + 2.0] = color.b

        stride1 += 1
        stride3 += 3
      }
    }

    var geometry = new THREE.BufferGeometry()

    geometry.addAttribute('mood', new THREE.BufferAttribute(mood, 1).setDynamic(true))
    geometry.addAttribute('position', new THREE.BufferAttribute(positions, 3))
    geometry.addAttribute('cellColor', new THREE.BufferAttribute(cellColorsArray, 3).setDynamic(true))
    geometry.addAttribute('borderColor', new THREE.BufferAttribute(borderColorsArray, 3).setDynamic(true))

    this.$emit('geometry-ready', { geometry, stridesMap })

    // geometry.computeBoundingSphere()
    // geometry.computeBoundingBox()

    let uniforms = {
      time: {
        value: 0
      },
      screen: {
        value: new THREE.Vector2(10, 10)
      },
      resolution: {
        value: resolution
      }
    }
    const material = new THREE.ShaderMaterial({
      alphaTest: 0.9,

      uniforms,
      // side: THREE.DoubleSide,
      transparent: true,
      vertexShader: `
        #include <common>
        varying vec3 vCellColor;
        varying vec3 vBorderColor;

        attribute vec3 cellColor;
        attribute vec3 borderColor;

        uniform vec2 resolution;
        uniform vec2 screen;
        uniform float time;

        attribute float mood;

        void main(){
          vec3 nPos = position;

          // nPos.x += nPos.x * sin(2.0 * time + nPos.y / resolution.y) * 0.001;
          // nPos.y += nPos.y * sin(2.0 * time + nPos.x / resolution.x) * 0.001;

          vec4 mvPosition = modelViewMatrix * vec4(nPos, 1.0);
          vec4 clipper = projectionMatrix * mvPosition;

          // mood 2.0 = can click on it
          if (mood == 2.0) {
            vCellColor = cellColor * abs(0.95 + 0.15 * sin(time * 5.0));
          } else {
            vCellColor = cellColor;
          }
          vBorderColor = borderColor;

          float aspect = resolution.y / resolution.x;
          float sy = resolution.y / screen.y;
          float sa = ${(this.engine.camera.position.z * 10).toFixed(1)} / -mvPosition.z;
          float dpi = 2.0;
          float pointSize = ${PARTICLE_SIZE.toFixed(1)};

          if (aspect > 1.0) {
            gl_PointSize = pointSize * dpi / 10.0 * sy * sa;
          } else {
            gl_PointSize = pointSize * dpi / 10.0 * sy * sa;
          }

          // if (aspect > 1.0) {
          //   gl_PointSize = pointSize * dpi / 10.0 * sy * sa;
          // } else {
          //   gl_PointSize = pointSize * dpi / 10.0 * sy * sa;
          // }

          gl_Position = clipper;
        }
      `,
      fragmentShader: `
        varying vec3 vCellColor;
        varying vec3 vBorderColor;

        uniform float time;
        uniform vec2 resolution;

        void main (void) {
          float dist = length(gl_PointCoord.xy - 0.5);
          if (dist > 0.5) {
            discard;
          } else {
            if (dist < 0.4) {
              gl_FragColor = vec4(vCellColor.rgb, 1.0);
            } else {
              gl_FragColor = vec4(vBorderColor.rgb, 1.0);
            }
          }
        }
      `
    })

    let tempBorderColor = new THREE.Color('#0A0721')

    // mood 2.0 = can click on it
    let setCellType = (numID, type) => {
      let attributes = geometry.attributes
      let stride = stridesMap[numID]
      attributes.mood.array[stride] = type
      attributes.mood.needsUpdate = true
    }

    let setBorderColorByNumID = (numID, myColor) => {
      // console.log(myColor)
      let attributes = geometry.attributes
      let stride = stridesMap[numID]
      tempBorderColor.set(myColor)
      let { r, g, b } = tempBorderColor
      attributes.borderColor.array[stride * 3.0 + 0.0] = r
      attributes.borderColor.array[stride * 3.0 + 1.0] = g
      attributes.borderColor.array[stride * 3.0 + 2.0] = b
      attributes.borderColor.needsUpdate = true
    }

    let tempBallColor = new THREE.Color('#0D092B')
    let setBallColorByNumID = (numID, myColor) => {
      // console.log(myColor)
      let attributes = geometry.attributes
      let stride = stridesMap[numID]
      tempBallColor.set(myColor)
      let { r, g, b } = tempBallColor
      attributes.cellColor.array[stride * 3.0 + 0.0] = r
      attributes.cellColor.array[stride * 3.0 + 1.0] = g
      attributes.cellColor.array[stride * 3.0 + 2.0] = b
      attributes.cellColor.needsUpdate = true
    }

    let onClick = () => {
      // let particles = this.pointcloud
      // let geometry = particles.geometry
      // let attributes = geometry.attributes

      let intersects = this.intersects || []
      if (intersects.length > 0) {
        console.log(intersects[0])
        let idx = intersects[0].index
        let brick = this.root.bricks[idx]

        console.log(JSON.stringify({ numID: brick.numID, 'xid': brick.xid, 'yid': brick.yid, brick }, null, '  '))

        this.$emit('click-brick', { numID: brick.numID, 'xid': brick.xid, 'yid': brick.yid, brick })
        this.$parent.$emit('click-brick', { numID: brick.numID, 'xid': brick.xid, 'yid': brick.yid, brick })

        // let { r, g, b } = new THREE.Color(brick.color)
        // attributes.cellColor.array[idx * 3.0 + 0.0] = r
        // attributes.cellColor.array[idx * 3.0 + 1.0] = g
        // attributes.cellColor.array[idx * 3.0 + 2.0] = b
        // attributes.cellColor.needsUpdate = true

        // setBallColorByNumID(brick.numID, '#ff00ff')
        // setBorderColorByNumID(brick.numID, '#ffff00')
      }
    }

    let lazyExec = (arr, fn) => {
      if (arr.length > 0) {
        let item = arr.pop()
        fn(item)
      }
    }

    let forEachOf = (arr, fn) => {
      requestIdleCallback(() => {
        arr.forEach(fn)
      }, { timeout: 2000 })
    }
    /*
    color.setHex(0x100B36)

        cellColorsArray[stride3 + 0.0] = color.r
        cellColorsArray[stride3 + 1.0] = color.g
        cellColorsArray[stride3 + 2.0] = color.b

        // color.setHSL(((counter - stride1) / counter), 1.0, 0.5)

        color.setHex(0x0A0721)
    */

    let whiter = (tile) => {
      setBallColorByNumID(tile.numID, 0x100B36)
      setBorderColorByNumID(tile.numID, 0x0A0721)
      setCellType(tile.numID, 1)
    }
    let tempColor = new THREE.Color()
    let userDataToStyles = () => {
      lazyExec(this.deadAround, whiter)
      lazyExec(this.deadCells, whiter)
      // lazyExec(this.cleaner, whiter)

      // cell cores
      this.players.forEach((player) => {
        let myColor = player.myColor
        let cellCore = player.gameInfo.cellCore
        setBallColorByNumID(cellCore.numID, '#ffffff')
        setBorderColorByNumID(cellCore.numID, myColor)
      })

      // my tiles possible moves
      let myColor = this.myInfo.myColor
      forEachOf(this.highlightTiles, ((tile) => {
        // tempColor.set(myColor)
        // tempColor.offsetHSL(0, -0.2, -0.41)
        tempColor.set(myColor)
        tempColor.offsetHSL(0, -0.2, -0.3)
        setBallColorByNumID(tile.numID, '#' + tempColor.getHexString())
        setBorderColorByNumID(tile.numID, '#' + tempColor.getHexString())

        setCellType(tile.numID, 2)
      }))

      // my cells
      forEachOf(this.activeTiles, ((tile) => {
        setBallColorByNumID(tile.numID, tile.color)
        tempColor.set(tile.color)
        tempColor.offsetHSL(0, 0.5, 0.3)
        setBorderColorByNumID(tile.numID, '#' + tempColor.getHexString())
      }))
    }

    let shouldBeClickEvent = false
    let isTouch = false
    let tt = 0
    let toucher = this.toucher
    toucher.addEventListener('click', () => {
      if (isTouch) {
        return
      }
      onClick()
    }, false)
    toucher.addEventListener('mousemove', () => {
      clearTimeout(tt)
      shouldBeClickEvent = false
    })
    toucher.addEventListener('touchstart', () => {
      isTouch = true
      shouldBeClickEvent = true
      setTimeout(() => {
        shouldBeClickEvent = false
      }, 300)
    })
    toucher.addEventListener('touchmove', (evt) => {
      console.log(evt)
    })
    toucher.addEventListener('touchend', () => {
      if (!shouldBeClickEvent) {
        return
      }
      shouldBeClickEvent = false
      onClick()
    }, false)

    let info = FSCalc({ zPos: 0, camera: this.engine.camera })
    uniforms.screen.value.x = info.width
    uniforms.screen.value.y = info.height

    raycaster.params.Points.threshold = PARTICLE_SIZE * 0.5

    this.$parent.$parent.$emit('add-exec', () => {
      if (this.hasLeft) {
        return
      }
      raycaster.setFromCamera(mouse, this.engine.camera)
      let intersects = raycaster.intersectObject(this.pointcloud)
      this.intersects = intersects

      // console.log(this.activeTiles)

      if (intersects.length > 0) {
        let idx = intersects[0].index
        let brick = this.root.bricks[idx]
        if (brick) {
          this.hover = { numID: brick.numID, 'xid': brick.xid, 'yid': brick.yid, brick }
        }

        toucher.style.cursor = `pointer`
      } else {
        this.hover = false
        toucher.style.cursor = 'auto'
      }

      // onClick()
      userDataToStyles()

      uniforms.time.value = window.performance.now() * 0.001
      material.needsUpdate = true
    })
    this.pointcloud = new THREE.Points(geometry, material)

    this.$emit('element', this.pointcloud)
    this.$parent.$emit('add', this.pointcloud)
  },
  beforeDestroy () {
    this.hasLeft = true
    this.$parent.$emit('remove', this.pointcloud)
  }
}
</script>

<style>

</style>
